export default __webpack_public_path__ + "static/media/404.3c89b513.svg";